'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024 from "./presto.-Edit-Group-Site-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457 from "./presto.-Presto-Router$$anon$57.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$56() {
  this.bjp = null;
  this.bjh = null;
  this.bji = false;
  this.bjq = null;
  this.bjr = false;
  this.bju = null;
  this.bjn = null;
  this.bjo = false;
  this.bjj = null;
  this.bjk = false;
  this.bjl = null;
  this.bjm = false;
  this.bjs = false;
  this.bjt = false;
  this.bjp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bju = "EditGroupSitePage";
}
export { $c_Lpresto_PrestoRouter$$anon$56 as $c_Lpresto_PrestoRouter$$anon$56 };
$p = $c_Lpresto_PrestoRouter$$anon$56.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$56;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$56() {
}
export { $h_Lpresto_PrestoRouter$$anon$56 as $h_Lpresto_PrestoRouter$$anon$56 };
$h_Lpresto_PrestoRouter$$anon$56.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bjp;
});
$p.M = (function() {
  if ((!this.bji)) {
    this.bjh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bji = true;
  }
  return this.bjh;
});
$p.O = (function() {
  if ((!this.bjr)) {
    this.bjq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bjr = true;
  }
  return this.bjq;
});
$p.E = (function() {
  return this.bju;
});
$p.t = (function() {
  if ((!this.bjo)) {
    this.bjn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bjo = true;
  }
  return this.bjn;
});
$p.N = (function() {
  if ((!this.bjk)) {
    this.bjj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mf(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bjk = true;
  }
  return this.bjj;
});
$p.Q = (function() {
  if ((!this.bjm)) {
    this.bjl = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002457.$c_Lpresto_PrestoRouter$$anon$57();
    this.bjm = true;
  }
  return this.bjl;
});
$p.v = (function() {
  if ((!this.bjt)) {
    this.bjs = false;
    this.bjt = true;
  }
  return this.bjs;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee427) => ((p) => \u03b4scrutinee427.cFs(p)))($j_presto$002e$002dEdit$002dGroup$002dSite$002dPage$0024.$m_Lpresto_EditGroupSitePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$56 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$56, "presto.PrestoRouter$$anon$56", ({
  Ox: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$56 as $d_Lpresto_PrestoRouter$$anon$56 };
//# sourceMappingURL=presto.-Presto-Router$$anon$56.js.map
